export const ALLPOST = 'posts/allpost';